import { useCallback } from 'react';
import { requestTotalFromSite } from '@ff-os/pdp-shared-redux/global-state/site-pricing';
import { IDT } from '@ff-os/pdp-shared-redux/IDT';
import { useExternalRender } from './useExternalRender';

export const useExternalTotalRender = (priceRequest: IDT.TotalPriceRequest) => {
    return useExternalRender(useCallback(async () => {
        return await requestTotalFromSite(priceRequest);
    }, [priceRequest]));
};